export default "__VITE_ASSET__DSZPvUqw__"